import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import * as XLSX from "xlsx";
import { InlineMath, BlockMath } from "react-katex";
import "katex/dist/katex.min.css";
import he from "he";
import axios from "axios";

const DownloadPaper = () => {
  const { id } = useParams();
  const [questions, setQuestions] = useState([]);
  const [fontSize, setFontSize] = useState("12px");
  const [boldQuestions, setBoldQuestions] = useState(false);
  const [showWatermark, setShowWatermark] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchQuestions();
  }, []);

  const fetchQuestions = async () => {
    try {
      setLoading(true);
      const fd = new FormData();
      fd.append("loggedInUser", "NC81dEdBVmlMVU56QVY2QURLL29Wdz09");
      fd.append("token", "kasejfksjdhfywterjwefbdskgfhsdfjh");
      fd.append("programType", "printQuestions");
      fd.append("paperId", id);

      const res = await axios.post(
        "https://qp.onezo.in/api/controller/picQuestion/picQuestionCurl",
        fd
      );

      setQuestions(res.data);
    } catch (err) {
      console.error("Error fetching questions:", err);
    } finally {
      setLoading(false);
    }
  };

  const renderLatexText = (text) => {
    if (!text) return null;
    const decoded = he.decode(text);
    const regex =
      /\\\((.*?)\\\)|\\\[(.*?)\\\]|<img[^>]*src=["']([^"']+)["'][^>]*>/g;

    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = regex.exec(decoded)) !== null) {
      parts.push(decoded.slice(lastIndex, match.index));
      if (match[1] || match[2]) {
        parts.push(
          <InlineMath key={match.index}>{match[1] || match[2]}</InlineMath>
        );
      } else if (match[3]) {
        parts.push(
          <div key={match.index} style={{ textAlign: "center" }}>
            <img src={match[3]} alt="Image" style={{ maxWidth: "100%" }} />
          </div>
        );
      }
      lastIndex = match.index + match[0].length;
    }

    if (lastIndex < decoded.length) {
      parts.push(decoded.slice(lastIndex));
    }

    return <span>{parts}</span>;
  };

  const handlePrint = () => {
    setTimeout(() => {
      window.print();
    }, 100);
  };

  const handleDownloadExcel = () => {
    const data = questions.map((q, index) => {
      return {
        "Q.No": index + 1,
        Question: he.decode(q.question),
        "Option A": q.options?.[0] || "",
        "Option B": q.options?.[1] || "",
        "Option C": q.options?.[2] || "",
        "Option D": q.options?.[3] || "",
        Answer: q.answer || "",
        Explanation: q.explanation || "",
      };
    });

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Question Paper");
    XLSX.writeFile(wb, "Question_Paper.xlsx");
  };

  return (
    <div style={{ padding: "1rem", fontSize }}>
      <h4 style={{ textAlign: "center" }}>📄 Paper View</h4>

      <div style={{ marginBottom: "1rem", display: "flex", flexWrap: "wrap", gap: "10px" }}>
       

        <button
          onClick={handleDownloadExcel}
          style={{
            padding: "5px 10px",
            backgroundColor: "green",
            color: "white",
            border: "none",
            borderRadius: "5px",
          }}
        >
          Download Excel
        </button>

         <label>
          Font Size:
          <select
            value={fontSize}
            onChange={(e) => setFontSize(e.target.value)}
            style={{ marginLeft: "5px" }}
          >
            <option value="10px">10px</option>
            <option value="12px">12px</option>
            <option value="14px">14px</option>
          </select>
        </label>

        <label>
          <input
            type="checkbox"
            checked={boldQuestions}
            onChange={() => setBoldQuestions(!boldQuestions)}
          />
          Bold
        </label>

        <label>
          <input
            type="checkbox"
            checked={showWatermark}
            onChange={() => setShowWatermark(!showWatermark)}
          />
          Watermark
        </label>

        <button
          onClick={handlePrint}
          style={{
            padding: "5px 10px",
            backgroundColor: "black",
            color: "white",
            border: "none",
            borderRadius: "5px",
          }}
        >
          Print
        </button>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        questions.map((q, index) => (
          <div
            key={index}
            style={{
              marginBottom: "1.5rem",
              position: "relative",
            }}
          >
            {showWatermark && (
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  color: "rgba(0,0,0,0.1)",
                  fontSize: "3rem",
                  pointerEvents: "none",
                  zIndex: 0,
                }}
              >
                CONFIDENTIAL
              </div>
            )}

            <p style={{ fontWeight: boldQuestions ? "bold" : "normal", zIndex: 1 }}>
              {index + 1}. {renderLatexText(q.question)}
            </p>

            <ul style={{ zIndex: 1 }}>
              {q.options?.map((opt, idx) => (
                <li key={idx}>
                  <strong>{String.fromCharCode(97 + idx)}.</strong>{" "}
                  {renderLatexText(opt)}
                </li>
              ))}
            </ul>

            <p style={{ zIndex: 1 }}>
              <strong>Answer:</strong> {renderLatexText(q.answer)}
            </p>

            {q.explanation && (
              <p style={{ zIndex: 1 }}>
                <strong>Explanation:</strong> {renderLatexText(q.explanation)}
              </p>
            )}
          </div>
        ))
      )}
    </div>
  );
};

export default DownloadPaper;
